// extracted by mini-css-extract-plugin
export default {"placeholder":"placeholder--lCgp5"};